import React from "react";

import { dispatchUserSlice } from "components/hooks/dispatchUserSlice";
import { useSlice } from "components/hooks/useSlice";
import { fetchBconnected } from "data/slices/users/bconnected";

import { BMailButton } from "./BConnectedButtons/BMailButton";
import { BCalButton } from "./BConnectedButtons/BCalButton";
import { BDriveButton } from "./BConnectedButtons/BDriveButton";
import { usePreSir } from "./hooks/usePreSir";

export function BConnectedButtons() {
  const isPreSir = usePreSir();
  const { hasBadges, isSlateUser } = useSlice("myStatus");

  if (!isPreSir && hasBadges && !isSlateUser) {
    return <BConnectedButtonsUI />;
  }

  return null;
}

function BConnectedButtonsUI() {
  dispatchUserSlice(fetchBconnected);

  return (
    <>
      <BMailButton />
      <BCalButton />
      <BDriveButton />
    </>
  );
}
